import {controller} from '@github/catalyst'
import {cookieExpiration} from './helpers'
import {getCookie, setCookie} from '@github-ui/cookies'

@controller
class GlobalBannerElement extends HTMLElement {
  connectedCallback() {
    if (this.hidden) return
    const disabledBanners = getCookie('disabled_global_site_banners')?.value.split(',') || []
    if (disabledBanners.includes(this.id)) this.hidden = true
  }

  close() {
    this.hidden = true
    this.updateCookie()
    document.dispatchEvent(new CustomEvent('global-banner:close'))
  }

  updateCookie(cookieName: string = 'disabled_global_site_banners', cookieExpirationDays: number = 30) {
    const existingCookie = getCookie(cookieName)?.value
    if (existingCookie) {
      const cookieValue = existingCookie
        .split(',')
        .filter(id => id !== this.id)
        .join(',')
      setCookie(cookieName, `${cookieValue},${this.id}`, cookieExpiration(cookieExpirationDays))
      return
    }
    setCookie(cookieName, this.id, cookieExpiration(cookieExpirationDays))
  }
}
